/**
 *
 * @type {{userConnected: null, myFavs: *[]}}
 * @private
 */

// State manager
const state = {
  facets: {},
  tmpQueryFilters: {},
  queryFilters: {},
  sort: 0,
  forYou: false,
};

// Getters
const getters = {
  getFacets: () => state.facets,
  getSort: () => state.sort,
  getQueryFilters: () => state.queryFilters,
  getTmpQueryFilters: () => state.tmpQueryFilters,
  getForYou: () => state.forYou,
};

// Asynchronous methods
const actions = {
  setFacets({ commit }, facets) {
    commit('SET_FACETS', facets);
  },
  setSort({ commit }, value) {
    commit('SET_SORT', value);
  },
  setForYou({ commit }, value) {
    commit('SET_FOR_YOU', value);
  },
  resetTmpQueryFilter({ commit }) {
    commit('RESET_TMP_QUERY_FILTER');
  },
  saveTmpQueryFilter({ commit }) {
    commit('SAVE_TMP_QUERY_FILTER');
  },
  deleteQueryFilter({ commit }, filterName) {
    commit('DELETE_QUERY_FILTER', filterName);
  },
  updateQueryFilter({ commit }, data) {
    commit('UPDATE_QUERY_FILTER', data);
  },
  resetQueryFilter({ commit }) {
    commit('RESET_QUERY_FILTER');
  },
};

/**
 * Synchronous methods
 * Used to change states
 */
const mutations = {
  SET_FACETS(localState, facets) {
    const currentState = localState;
    currentState.facets = facets;
  },
  SET_SORT(localState, value) {
    const currentState = localState;
    currentState.sort = value;
  },
  SET_FOR_YOU(localState, value) {
    const currentState = localState;
    currentState.forYou = value;
  },
  RESET_TMP_QUERY_FILTER(localState) {
    const currentState = localState;
    currentState.tmpQueryFilters = JSON.parse(JSON.stringify(state.queryFilters));
  },
  SAVE_TMP_QUERY_FILTER(localState) {
    const currentState = localState;
    currentState.queryFilters = JSON.parse(JSON.stringify(state.tmpQueryFilters));
  },
  DELETE_QUERY_FILTER(localState, filterName) {
    const currentState = localState;
    if (currentState.queryFilters && currentState.queryFilters[filterName]) {
      delete currentState.queryFilters[filterName];
    }

    // Force update
    currentState.queryFilters = { ...currentState.queryFilters };
  },
  UPDATE_QUERY_FILTER(localState, data) {
    const currentState = localState;
    let stateKey = 'queryFilters';

    if (data.tmp) {
      stateKey = 'tmpQueryFilters';
    }

    if (data.checked) {
      if (
        !currentState[stateKey][data.filterName]
        || !Array.isArray(currentState[stateKey][data.filterName])
      ) {
        currentState[stateKey][data.filterName] = [];
      }

      if (currentState[stateKey][data.filterName].indexOf(data.filterItemId) === -1) {
        currentState[stateKey][data.filterName].push(data.filterItemId);
      }
    } else if (
      currentState[stateKey][data.filterName]
      && Array.isArray(currentState[stateKey][data.filterName])
      && currentState[stateKey][data.filterName].length
    ) {
      const index2Delete = currentState[stateKey][data.filterName].indexOf(data.filterItemId);

      if (index2Delete !== -1) {
        currentState[stateKey][data.filterName].splice(index2Delete, 1);

        if (currentState[stateKey][data.filterName].length === 0) {
          delete currentState[stateKey][data.filterName];
        }
      }
    }

    // Force update
    currentState[stateKey] = { ...currentState[stateKey] };
  },
  RESET_QUERY_FILTER(localState) {
    const currentState = localState;
    currentState.queryFilters = {};
  },
};

// export store module
export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
